import AnonymityNavigationGuard from '@/router/guards/AnonymityNavigationGuard'
import AuthenticationNavigationGuard from '@/router/guards/AuthenticationNavigationGuard'
import AutoLoginNavigationGuard from '@/router/guards/AutoLoginNavigationGuard'
import ContextNavigationGuard from '@/router/guards/ContextNavigationGuard'
import ForcedPasswordRenewalNavigationGuard from '@/router/guards/ForcedPasswordRenewalNavigationGuard'
import HistoryNavigationGuard from '@/router/guards/HistoryNavigationGuard'
import PasswordExpirationNavigationGuard from '@/router/guards/PasswordExpirationNavigationGuard'
import KeycloakRedirectGuard from '@/router/guards/KeycloakRedirectGuard'
import UserTypeNavigationGuard from '@/router/guards/UserTypeNavigationGuard'
import EmbeddedNavigationGuard from '@/router/guards/EmbeddedNavigationGuard'

const GUARDS = []

GUARDS.push(AutoLoginNavigationGuard)
GUARDS.push(AuthenticationNavigationGuard)
GUARDS.push(ForcedPasswordRenewalNavigationGuard)
// Doit être authentifié (guard précédent) avant qu'on regarde s'il doit
GUARDS.push(PasswordExpirationNavigationGuard)
GUARDS.push(KeycloakRedirectGuard)
GUARDS.push(AnonymityNavigationGuard)
GUARDS.push(UserTypeNavigationGuard)
GUARDS.push(ContextNavigationGuard)
GUARDS.push(HistoryNavigationGuard)
GUARDS.push(EmbeddedNavigationGuard)

let lastFullPath

export default function (to, from) {
	let result = true
	for (const guard of GUARDS) {
		const guardResult = guard(to, from, lastFullPath)
		if (guardResult !== true) {
			result = guardResult
			break
		}
	}

	if (typeof result == 'string') {
		lastFullPath = result
	} else if (result === true) {
		lastFullPath = to.fullPath
	} else if (typeof result == 'object' && result !== null) {
		lastFullPath = result.fullPath
	}

	return result
}
